import { IMemberTypes } from 'components/Collectives/Demo/common'
import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import {
  CollectiveProposalStatus,
  CollectiveProposalExecutionStatus
} from 'graphql/generated'
import { useCallback } from 'react'
import { useSignProposal } from './useSignProposal'

export const useExecuteProposal = () => {
  const {
    collectiveDemo,
    collectiveMembers,
    setCollectiveMembers,
    currentUser,
    updateDemoCache,
    possibleMembers,
    setPossibleMembers
  } = useCollectiveDemoContext()

  const signProposal = useSignProposal()

  const executeProposal = useCallback(
    (id: string, signator: IMemberTypes = currentUser) => {
      if (!collectiveDemo) {
        return
      }

      const newProposalData = signProposal(id, signator)

      if (!newProposalData) {
        return
      }

      const newProposal = newProposalData.proposal
      if (!newProposal?.signatures) {
        return
      }

      const newCollectiveDemo = { ...collectiveDemo }

      const newCollectiveMembers = { ...collectiveMembers }

      if (newCollectiveDemo.safeThreshold === newProposal.signatures.length) {
        newProposal.status = CollectiveProposalStatus.EXECUTED
        newProposal.execution = {
          txHash: '23234',
          blockNumber: 333234234234,
          __typename: 'CollectiveProposalExecution',
          status: CollectiveProposalExecutionStatus.SUCCEEDED
        }
        newProposal.canVote = false

        // specifix proposal actions
        const addMemberCommand = newProposal.commands.find(
          com => com.__typename === 'CollectiveProposalAddMemberCommand'
        ) as {
          __typename: 'CollectiveProposalAddMemberCommand'
          memberAddress: string
        }

        const membersNew = [...possibleMembers]

        if (addMemberCommand) {
          newCollectiveDemo.totalMembers = newCollectiveDemo.totalMembers + 1

          newCollectiveDemo.totalMembershipRequests =
            newCollectiveDemo.totalMembershipRequests - 1

          const memberAdding = membersNew.find(
            type => type.address === addMemberCommand.memberAddress
          )

          if (memberAdding) {
            memberAdding.membership.approved = true

            newCollectiveMembers.edges = [
              {
                __typename: 'CollectiveMemberEdge',
                cursor: '',
                node: memberAdding.membership
              },
              ...newCollectiveMembers.edges
            ]
          }
        }

        const addSignatorCommand = newProposal.commands.find(
          com => com.__typename === 'CollectiveProposalAddSignatorCommand'
        ) as {
          __typename: 'CollectiveProposalAddSignatorCommand'
          signatorAddress: string
        }

        if (addSignatorCommand) {
          const memberAdding = membersNew.find(
            type => type.address === addSignatorCommand.signatorAddress
          )

          if (memberAdding) {
            memberAdding.membership.approved = true
            memberAdding.membership.privileged = true
          }
        }

        setPossibleMembers(membersNew)
        setCollectiveMembers(newCollectiveMembers)

        updateDemoCache(newCollectiveDemo)
      }
    },
    [
      collectiveDemo,
      collectiveMembers,
      currentUser,
      possibleMembers,
      setCollectiveMembers,
      setPossibleMembers,
      signProposal,
      updateDemoCache
    ]
  )

  return executeProposal
}
